<template>
  <div class="lesson-box">
    <div class="lesson-box__left">
      <IconLesson />
      <router-link :to="`/lesson/${lesson.id}`" class="lesson-box__title">
        <strong>{{ lesson.title }}</strong>
      </router-link>
    </div>
    <div class="lesson-box__right">
      <span>{{ formatDate(lesson.start.seconds) }}</span>
      <v-btn
        depressed
        color="secondary"
        rounded
        class="color-primary"
        @click="recycleLesson(lesson.id)"
      >
        <v-icon class="pe-5" right dark>mdi-refresh</v-icon>
        {{ $t('recycle') }}
      </v-btn>
      <v-btn
        class="ma-2"
        color="#9190a1"
        icon
        style="text-decoration:none"
        @click.stop="openDelete(lesson.id)"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import IconLesson from '@/assets/icon-lesson.svg';

export default {
  components: {
    IconLesson,
  },
  data() {
    return {};
  },
  props: {
    lesson: {
      type: Object,
      required: true,
    },
  },

  methods: {
    openDelete(id) {
      this.$emit('open-delete', id);
    },
    recycleLesson(id) {
      this.$emit('recycle-lesson', id);
    },
    formatDate(seconds) {
      const momentDate = moment.unix(seconds);
      return `${momentDate
        .locale('cs')
        .format('dddd D. M. YYYY')} od ${momentDate.format('HH:mm')}`;
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}
.lesson-box {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 30px;
  padding-right: 30px;

  display: flex;
  justify-content: space-between;
  text-decoration: none;
  color: #17173a;

  border: 1px solid transparent;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(#d8d8d8, 0.15);
    border-color: rgba(#979797, 0.15);
    border-radius: 6px;

    strong {
      text-decoration: underline;
    }
  }

  &__title {
    text-decoration: none;
    color: #17173a;
  }

  &__left {
    display: flex;
    align-items: center;

    svg {
      width: 22px;
      display: block;
      margin-right: 20px;
      g {
        fill: #8b8b9d;
      }
    }

    strong {
      display: block;
      font-size: 14px;
      padding: 0 10px !important;
    }
  }

  &__right {
    flex-direction: row;
    display: flex;
    z-index: 10;
    margin: auto;
    margin-right: 0;
    align-items: center;
    span {
      display: block;
      font-size: 13px;
      opacity: 0.5;
      padding-right: 20px;
      margin: auto;
    }
  }
}

@media only screen and (max-width: 968px) {
  .lesson-box {
    flex-direction: column !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    &__left {
      flex-direction: column !important;
      align-items: flex-start !important;
      svg {
        margin-right: 0px !important;
      }
      strong {
        padding: 5px 0 0 0 !important;
      }
    }
    &__right {
      margin-left: 0 !important;
    }
  }
}
</style>
